export default {
  DEFAULT: 18,
  xxs: 18,
  xs: 18,
  sm: 30,
  smDialog: 30,
  md: 30,
  lg: 30,
  xl: 30,
  xxl: 30,
};
